import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { DataService } from "../../../services/data.service";
import { TranslateService } from "@ngx-translate/core";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { SpinnerService } from "shared-components";

@Component({
  selector: "app-avisos-cultivos",
  templateUrl: "./avisos-cultivos.component.html",
})
export class AvisosCultivosComponent
  implements OnInit, OnDestroy
{
  public cargaCompleta = false;
  // Este número se deberá devolver desde back mediante un servicio al acceder a la pantalla
  public totalAvisos = 5;

  public cultivosSinDesignaciones = [];
  public datosCultivosSinDesignaciones = [];

  public aforoActualAnterior = [];
  public datosAforoActualAnterior = [];

  public allDonuts = [];
  public donutsPorPrioridad = [];

  public colors = [
    {
      backgroundColor: ["rgba(22,97,76,255)", "rgba(22,97,76,0.4)"],
    },
    {
      backgroundColor: ["rgba(251,128,45,255)", "rgba(251,128,45,0.4)"],
    },
    {
      backgroundColor: ["rgba(193,72,72,255)", "rgba(193,72,72,0.4)"],
    },
  ];

  public toCloseSpinner = 0;

  public gridModal = false;
  public tituloGrid;

  public showAll = true;

  public animation;

  @Input() set priority(value: string) {
    if (value === "ALTA") {
      this.showAll = false;
      this.donutsPorPrioridad = this.allDonuts.filter(
        (donut) =>
          donut.colors.backgroundColor[0].toString() ===
          this.colors[2].backgroundColor[0].toString()
      );
    } else if (value === "MEDIA") {
      this.showAll = false;
      this.donutsPorPrioridad = this.allDonuts.filter(
        (donut) =>
          donut.colors.backgroundColor[0].toString() ===
          this.colors[1].backgroundColor[0].toString()
      );
    } else if (value === "BAJA") {
      this.showAll = false;
      this.donutsPorPrioridad = this.allDonuts.filter(
        (donut) =>
          donut.colors.backgroundColor[0].toString() ===
          this.colors[0].backgroundColor[0].toString()
      );
    } else {
      this.showAll = true;
      this.donutsPorPrioridad = [];
    }
  }

  @Input() set startAnimation(value: boolean) {
    this.animation = value;
  }

  @Input() donutsCultivosInput;
  @Output() donutsCultivosOutput = new EventEmitter<any>();
  @Output() disableFilters = new EventEmitter();
  @Output() numAvisosTotales = new EventEmitter();
  @Output() numAvisos = new EventEmitter();

  constructor(
    private readonly _dataService: DataService,
    private readonly _sessionContext: SessionContextService,
    private readonly _spinnerService: SpinnerService,
    private readonly _translate: TranslateService
  ) {}

  ngOnInit() {
    if (this.donutsCultivosInput) {
      this.allDonuts = this.donutsCultivosInput;
      this.cargaCompleta = true;
    } else {
      const promises: Promise<any>[] = [];

      promises.push(this.getCultivosSinDesignacion());

      promises.push(this.getKgAforo({ min: null, max: 70 }, "<"));
      promises.push(this.getKgAforo({ min: 70, max: 80 }, "<"));
      promises.push(this.getKgAforo({ min: 120, max: 130 }, ">"));
      promises.push(this.getKgAforo({ min: 130, max: null }, ">"));

      this.disableFilters.emit(true);
      this.numAvisosTotales.emit(this.totalAvisos);
      Promise.all(promises)
        .then(
          () => {
            this.agruparInfo();
            this.disableFilters.emit(false);
            this.cargaCompleta = true;
          },
          (error) => {
            console.log("Promise rejected with " + JSON.stringify(error));
          }
        )
        .catch((e) => console.log(e));
    }

    // Descomentar si hay problemas en el redibujado
    // window.onfocus = (e) => {
    //     this.dibujarDonuts();
    // };
  }

  ngOnDestroy() {
    this.donutsCultivosOutput.emit(this.allDonuts);
  }

  // private dibujarDonuts() {
  //     this.datosCultivosSinDesignaciones.forEach((cultivo, index) => {
  //         this.cultivosSinDesignaciones[index] = {
  //             label: 'Cultivos sin designación',
  //             subLabel: '',
  //             descripcion: 'Cultivos sobre los que todavía no se ha creado ninguna designación.',
  //             labelList: ['Con designación', 'Sin designación'],
  //             dataList: [cultivo.porcentaje, (100 - cultivo.porcentaje).toFixed(2), cultivo.numerador + '/' + cultivo.denominador],
  //             colors: cultivo.color
  //         };
  //     });

  //     this.datosAforoActualAnterior.forEach((kgAforo, index) => {
  //         this.aforoActualAnterior[index] = {
  //             label: kgAforo.label,
  //             subLabel: kgAforo.subLabel,
  //             descripcion: kgAforo.descripcion,
  //             labelList:  ['Con decremento', 'Sin decremento'],
  //             dataList: [kgAforo.porcentaje,
  //             (100 - kgAforo.porcentaje).toFixed(2), kgAforo.numerador + '/' + kgAforo.denominador],
  //             colors: kgAforo.color
  //         };
  //     });
  // }

  public getCultivosSinDesignacion(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._spinnerService.showSpinner();
      if (this.toCloseSpinner === 0) {
        this.toCloseSpinner += 1;
      }
      this._dataService
        .getCultivosSinDesignaciones()
        .toPromise()
        .finally(() => {
          this.checkCloseSpinner();
          this.numAvisos.emit(1);
        })
        .then(
          (resp) => {
            if (resp) {
              this.datosCultivosSinDesignaciones[0] = {
                descripcion: this._translate.instant(
                  "central-avisos.cultivos.cultivosSinDesignaciones.descripcion"
                ),
                porcentaje: resp.porcentaje,
                numerador: resp.numerador,
                denominador: resp.denominador,
                color: this.colors[resp.centralAvisosPrioridadId - 1],
                prioridad: resp.centralAvisosPrioridadId - 1,
              };
              this.cultivosSinDesignaciones[0] = {
                label: this._translate.instant(
                  "central-avisos.cultivos.cultivosSinDesignaciones.label"
                ),
                subLabel: "",
                descripcion: this._translate.instant(
                  "central-avisos.cultivos.cultivosSinDesignaciones.descripcion"
                ),
                labelList: [
                  this._translate.instant("central-avisos.cumplenCondicion"),
                  this._translate.instant("central-avisos.noCumplenCondicion"),
                ],
                dataList: [
                  resp.porcentaje,
                  (100 - resp.porcentaje).toFixed(2),
                  resp.numerador + "/" + resp.denominador,
                ],
                colors: this.colors[resp.centralAvisosPrioridadId - 1],
              };
            }
            setTimeout(resolve, 1);
          },
          (error) => {
            setTimeout(resolve, 1);
          }
        );
    });
  }

  public getKgAforo(porcentajes, operador): Promise<any> {
    return new Promise((resolve, reject) => {
      let filters;
      if (operador === "<" && !porcentajes.min) {
        filters = {
          porcentajeMax: porcentajes.max,
        };
      } else if (operador === "<" && porcentajes.max) {
        filters = {
          porcentajeMin: porcentajes.min,
          porcentajeMax: porcentajes.max,
        };
      } else if (operador === ">" && porcentajes.max === 130) {
        filters = {
          porcentajeMin: porcentajes.min,
          porcentajeMax: porcentajes.max,
        };
      } else if (operador === ">" && !porcentajes.max) {
        filters = {
          porcentajeMin: porcentajes.min,
        };
      }
      this._spinnerService.showSpinner();
      if (this.toCloseSpinner === 0) {
        this.toCloseSpinner += 1;
      }
      this._dataService
        .getKgAforoRespectoAnterior(filters)
        .toPromise()
        .finally(() => {
          this.checkCloseSpinner();
          this.numAvisos.emit(1);
        })
        .then(
          (resp) => {
            if (resp) {
              if (operador === "<" && !porcentajes.min) {
                this.datosAforoActualAnterior[0] = {
                  descripcion: this._translate.instant(
                    "central-avisos.cultivos.aforoActualAnterior.descripcionMenos70"
                  ),
                  label:
                    this._translate.instant(
                      "central-avisos.cultivos.aforoActualAnterior.preLabel"
                    ) +
                    operador +
                    this._translate.instant(
                      "central-avisos.cultivos.aforoActualAnterior.postLabel"
                    ),
                  subLabel: "(<70%)",
                  porcentaje: resp.porcentaje,
                  numerador: resp.numerador,
                  denominador: resp.denominador,
                  color: this.colors[resp.centralAvisosPrioridadId - 1],
                  prioridad: resp.centralAvisosPrioridadId - 1,
                };

                this.aforoActualAnterior[0] = {
                  label:
                    this._translate.instant(
                      "central-avisos.cultivos.aforoActualAnterior.preLabel"
                    ) +
                    operador +
                    this._translate.instant(
                      "central-avisos.cultivos.aforoActualAnterior.postLabel"
                    ),
                  subLabel: "(<70%)",
                  descripcion: this._translate.instant(
                    "central-avisos.cultivos.aforoActualAnterior.descripcionMenos70"
                  ),
                  labelList: [
                    this._translate.instant("central-avisos.cumplenCondicion"),
                    this._translate.instant(
                      "central-avisos.noCumplenCondicion"
                    ),
                  ],
                  dataList: [
                    resp.porcentaje,
                    (100 - resp.porcentaje).toFixed(2),
                    resp.numerador + "/" + resp.denominador,
                  ],
                  colors: this.colors[resp.centralAvisosPrioridadId - 1],
                };
              } else if (operador === "<" && porcentajes.max) {
                this.datosAforoActualAnterior[1] = {
                  descripcion: this._translate.instant(
                    "central-avisos.cultivos.aforoActualAnterior.descripcion7800"
                  ),
                  label:
                    this._translate.instant(
                      "central-avisos.cultivos.aforoActualAnterior.preLabel"
                    ) +
                    operador +
                    this._translate.instant(
                      "central-avisos.cultivos.aforoActualAnterior.postLabel"
                    ),
                  subLabel: "(70%-80%)",
                  porcentaje: resp.porcentaje,
                  numerador: resp.numerador,
                  denominador: resp.denominador,
                  color: this.colors[resp.centralAvisosPrioridadId - 1],
                  prioridad: resp.centralAvisosPrioridadId - 1,
                };

                this.aforoActualAnterior[1] = {
                  label:
                    this._translate.instant(
                      "central-avisos.cultivos.aforoActualAnterior.preLabel"
                    ) +
                    operador +
                    this._translate.instant(
                      "central-avisos.cultivos.aforoActualAnterior.postLabel"
                    ),
                  subLabel: "(70%-80%)",
                  descripcion: this._translate.instant(
                    "central-avisos.cultivos.aforoActualAnterior.descripcion7080"
                  ),
                  labelList: [
                    this._translate.instant("central-avisos.cumplenCondicion"),
                    this._translate.instant(
                      "central-avisos.noCumplenCondicion"
                    ),
                  ],
                  dataList: [
                    resp.porcentaje,
                    (100 - resp.porcentaje).toFixed(2),
                    resp.numerador + "/" + resp.denominador,
                  ],
                  colors: this.colors[resp.centralAvisosPrioridadId - 1],
                };
              } else if (operador === ">" && porcentajes.max === 130) {
                this.datosAforoActualAnterior[2] = {
                  descripcion: this._translate.instant(
                    "central-avisos.cultivos.aforoActualAnterior.descripcion2030"
                  ),
                  label:
                    this._translate.instant(
                      "central-avisos.cultivos.aforoActualAnterior.preLabel"
                    ) +
                    operador +
                    this._translate.instant(
                      "central-avisos.cultivos.aforoActualAnterior.postLabel"
                    ),
                  subLabel: "(20%-30%)",
                  porcentaje: resp.porcentaje,
                  numerador: resp.numerador,
                  denominador: resp.denominador,
                  color: this.colors[resp.centralAvisosPrioridadId - 1],
                  prioridad: resp.centralAvisosPrioridadId - 1,
                };

                this.aforoActualAnterior[2] = {
                  label:
                    this._translate.instant(
                      "central-avisos.cultivos.aforoActualAnterior.preLabel"
                    ) +
                    operador +
                    this._translate.instant(
                      "central-avisos.cultivos.aforoActualAnterior.postLabel"
                    ),
                  subLabel: "(20%-30%)",
                  descripcion: this._translate.instant(
                    "central-avisos.cultivos.aforoActualAnterior.descripcion2030"
                  ),
                  labelList: [
                    this._translate.instant("central-avisos.cumplenCondicion"),
                    this._translate.instant(
                      "central-avisos.noCumplenCondicion"
                    ),
                  ],
                  dataList: [
                    resp.porcentaje,
                    (100 - resp.porcentaje).toFixed(2),
                    resp.numerador + "/" + resp.denominador,
                  ],
                  colors: this.colors[resp.centralAvisosPrioridadId - 1],
                };
              } else if (operador === ">" && !porcentajes.max) {
                this.datosAforoActualAnterior[3] = {
                  descripcion: this._translate.instant(
                    "central-avisos.cultivos.aforoActualAnterior.descripcionMas30"
                  ),
                  label:
                    this._translate.instant(
                      "central-avisos.cultivos.aforoActualAnterior.preLabel"
                    ) +
                    operador +
                    this._translate.instant(
                      "central-avisos.cultivos.aforoActualAnterior.postLabel"
                    ),
                  subLabel: "(>30%)",
                  porcentaje: resp.porcentaje,
                  numerador: resp.numerador,
                  denominador: resp.denominador,
                  color: this.colors[resp.centralAvisosPrioridadId - 1],
                  prioridad: resp.centralAvisosPrioridadId - 1,
                };

                this.aforoActualAnterior[3] = {
                  label:
                    this._translate.instant(
                      "central-avisos.cultivos.aforoActualAnterior.preLabel"
                    ) +
                    operador +
                    this._translate.instant(
                      "central-avisos.cultivos.aforoActualAnterior.postLabel"
                    ),
                  subLabel: "(>30%)",
                  descripcion: this._translate.instant(
                    "central-avisos.cultivos.aforoActualAnterior.descripcionMas30"
                  ),
                  labelList: [
                    this._translate.instant("central-avisos.cumplenCondicion"),
                    this._translate.instant(
                      "central-avisos.noCumplenCondicion"
                    ),
                  ],
                  dataList: [
                    resp.porcentaje,
                    (100 - resp.porcentaje).toFixed(2),
                    resp.numerador + "/" + resp.denominador,
                  ],
                  colors: this.colors[resp.centralAvisosPrioridadId - 1],
                };
              }
            }
            setTimeout(resolve, 1);
          },
          (error) => {
            setTimeout(resolve, 1);
          }
        );
    });
  }

  private agruparInfo() {
    for (let cultivo of this.cultivosSinDesignaciones) {
      this.allDonuts.push(cultivo);
    }

    for (let kgAforo of this.aforoActualAnterior) {
      this.allDonuts.push(kgAforo);
    }
  }

  private checkCloseSpinner() {
    if (this.toCloseSpinner === 1) {
      this.toCloseSpinner -= 1;
    }
    if (this.toCloseSpinner === 0) {
      this._spinnerService.hideSpinner();
    }
  }

  public showGrid(donut) {
    this.tituloGrid = donut.label + " " + donut.subLabel;
    this.gridModal = true;
  }

  public refresh(value) {
    this.gridModal = false;
  }
}
